// https://github.com/zefoy/ngx-perfect-scrollbar
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';

export const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface =
  {
    suppressScrollX: true
  };
